import { mapState } from '@/store/helpers';

export default {
    data: function() {
        return {
            placeStyle: null
        };
    },
    computed: {
        ...mapState({
            "onlyMap": store => store.layout === 'map',
            "composeLayout": store => store.layout === 'mixed'
        }),
    },
    methods: {
        computedStyle({ composeLayout }) {
            let searchBarHeight = this.$refs.listingSearch.$el.offsetHeight;
            if (composeLayout) {
                this.placeStyle = {
                    resultHead: searchBarHeight,
                    searchBar: 0
                };
            } else {
                this.placeStyle = {
                    resultHead: 0,
                    searchBar: searchBarHeight
                };
            }
        },
    }
};
